import { variables, $ } from '../common/variables';
import { cl, ajax } from '../common/functions';

const fieldEdit = (elements) => {
  if (!!elements.length) {
    /*------------ [AJAX] function------------*/
    const action = 'edit_fields_ajax';

    /*------------ [AJAX] success------------*/
    const success = res => {
      let notyf = new Notyf();
      let data = res;
      if (data.success === true) {
        notyf.success('Your changes have been successfully saved!');
      } else {
        notyf.error('Oops something went wrong');
      }
    };

    /*------------ [AJAX] error------------*/
    const error = err => {
      let notyf = new Notyf();
      notyf.error('Oops something went wrong');
      cl(err);
    };


    [...elements].forEach(field => {
      if (field.tagName !== 'DIV') {
        if (field.tagName === "INPUT") {
          let editField = (event) => {
            field.addEventListener(event, e => {
              if (e.keyCode === 13 || event === 'focusout') {
                let value = e.target.value;
                let id = e.target.getAttribute('data-id');
                let fieldname = e.target.getAttribute('data-fieldname');
                let table = e.target.getAttribute('data-table');
                if (e.target.classList.contains('gl__color') === true) {
                  let parent = e.target.parentNode;
                  let colorInput = parent.querySelector(".input-box__color");
                  if (colorInput !== null) {
                    colorInput.style.setProperty("--background-color", e.target.value);
                  }
                }
                const params = {
                  action: action,
                  id: id,
                  value: value,
                  fieldname: fieldname,
                  table: table,
                };

                if (field.classList.contains('ajax__edit--options')) {
                  params.options = true;
                  if (field.classList.contains('ajax__edit--options-subcategory')) {
                    params.counter = e.target.dataset.counter;
                    params.subfieldname = e.target.dataset.subfieldname;
                  }
                }

                ajax(params, success, error, 'json');
              }
            });
          }
          editField('keyup');
          editField('focusout');
          if (field.classList.contains('gl__address') === true) {
            field.addEventListener('focus', (element) => {
              element.preventDefault();
              let id = element.target.id;
              if (window.jQuery) {
                let $ = jQuery.noConflict();
                /*------------ [JQUERY UI] ------------*/
                let $input = $(`#${id}`);
                //Autocomplete
                $input.autocomplete({
                  source: (request, response) => {
                    $.ajax({
                      url: 'https://api-adresse.data.gouv.fr/search/?q={s}', // France only
                      // url: 'https://nominatim.openstreetmap.org/search?format=json&q={s}',
                      data: { q: request.term },
                      dataType: 'json',
                      success: res => {
                        response(
                          $.map(res.features, item => {
                            return {
                              label: item.properties.label,
                              latitude: item.geometry.coordinates[1],
                              longitude: item.geometry.coordinates[0]
                            };
                          })
                          // $.map(res, item => {
                          //   return {
                          //     label: item.display_name,
                          //     latitude: item.lat,
                          //     longitude: item.lon
                          //   };
                          // })
                        );
                      }
                    });
                  },
                  //remplis les champs avec les values retournées
                  select: (event, e) => {
                    $input.innerHTML = e.item.label;
                    const map = leafletLib.map;
                    map.removeLayer(leafletLib.marker);
                    const marker = L.marker([e.item.latitude, e.item.longitude]).addTo(map);
                    const changeCoordinates = (element, coordinate) => {
                      element.value = coordinate;
                      const id = element.dataset.id;
                      const fieldname = element.dataset.fieldname;
                      const table = element.dataset.table;
                      ajax(coordinate, id, fieldname, table, null);
                    }
                    map.setView([e.item.latitude, e.item.longitude], 5);

                    const longitudeElement = element.target.parentNode.parentNode.parentNode.querySelector(".gl__longitude");
                    !!longitudeElement && changeCoordinates(longitudeElement, e.item.longitude);
                    !!longitudeElement && longitudeElement.focus();

                    const latitudeElement = element.target.parentNode.parentNode.parentNode.querySelector(".gl__latitude");
                    !!latitudeElement && changeCoordinates(latitudeElement, e.item.latitude);
                    !!latitudeElement && latitudeElement.focus();

                    field.focus();
                  }
                });
              }
            });
          }
          if (field.type === "radio") {
            field.addEventListener('click', (e) => {
              // e.preventDefault();
              const id = e.target.dataset.id;
              const fieldname = e.target.dataset.fieldname;
              const table = e.target.dataset.table;
              const value = e.target.dataset.value;
              const params = {
                action: action,
                id: id,
                fieldname: fieldname,
                table: table,
                value: value,
              };
              field.classList.contains('ajax__edit--options') ? params.options = true : null;
              ajax(params, success, error, 'json');
            });
          }
        } else if (field.tagName === "SELECT") {
          field.addEventListener('change', (e) => {
            e.preventDefault();
            const id = e.target.dataset.id;
            const fieldname = e.target.dataset.fieldname;
            const table = e.target.dataset.table;
            const params = {
              action: action,
              id: id,
              fieldname: fieldname,
              table: table,
            };
            let value;
            if (!field.multiple) {
              if (field.classList.contains('gl__category')) {
                value = e.target.options[e.target.selectedIndex].value;
              } else {
                value = e.target.options[e.target.selectedIndex].dataset.typeid;
                const name = e.target.value;
                const thisId = e.target.id;
                const otherSelect = e.target.parentNode.parentNode.parentNode.querySelector(`select:not(#${thisId})`);
                if (otherSelect) {
                  [...otherSelect.options].forEach(option => {
                    option.removeAttribute('disabled');
                    if (option.dataset.typeid === value) {
                      option.setAttribute("disabled", "disabled");
                    }
                  });
                }
                params.name = name;
              }
            } else {
              value = Array.from(e.target.selectedOptions).map(v => v.value);
              value = JSON.stringify(value);
            }
            params.value = value;
            field.classList.contains('ajax__edit--options') ? params.options = true : null;

            ajax(params, success, error, 'json');
          });
        }
      }
    });
  }
}

export { fieldEdit };
